import { render, staticRenderFns } from "./HealthOnboardingGate.vue?vue&type=template&id=2fbc246e&"
import script from "./HealthOnboardingGate.vue?vue&type=script&lang=ts&"
export * from "./HealthOnboardingGate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports